<template>
    <div class="app-container">
        <div v-loading="loading" class="myIncome">
            <div class="title">我的收益</div>
            <div class="income-info">
                <div class="income-info-item">
                    <div class="item">
                        <span>￥{{ cashBack_detail.total || 0 }}</span>
                    </div>
                    <div :style="{fontSize: '22px'}">累计收益</div>
                </div>
                <div class="income-info-item">
                    <div class="item-2">
                        <span class="item-text-1">￥{{ cashBack_detail.waitConfirm || 0 }}</span>
                    </div>
                    <div class="item-text-2">待确认结果金额</div>
                    <el-button class="item-text-3" @click="toOrderList">确认结果</el-button>
                </div>
                <div class="income-info-item">
                    <div class="item-2">
                        <span class="item-text-1">￥{{ cashBack_detail.totalFreeze || 0 }}</span>
                    </div>
                    <div class="item-text-2">冻结</div>
                    <el-button class="item-text-3" @click="toInvoiceList">上传凭证</el-button>
                    <div class="item-text-4">冻结金额待订单回款后即可领取</div>
                </div>
                <div class="income-info-item">
                    <div class="item-2">
                        <span class="item-text-1">￥{{ cashBack_detail.totalWithDrown || 0 }}</span>
                    </div>
                    <div class="item-text-2">已提现</div>
                </div>
            </div>
        </div>
        <div v-loading="loading" class="redPacket-explain">
            <div class="explain-text-2">已确认结果金额为 <span class="explain-text-1">{{ cashBack_detail.comfirm || 0 }}</span> 元，最高可抽 <span class="explain-text-1">{{ cashBack_detail.giveMax || 0 }}</span>元现金红包 </div>
            <div class="explain-text-3">确认结果金额越高，抽奖比例越高</div>
        </div>
        <div class="redPacket-box">
            <img src="https://pstatic.navi-sci.cn/cashBack_act/pc_cashBack_1.png" alt="" @click="openQRcodeBox('pages/index/index', 400, 0)">
            <img src="https://pstatic.navi-sci.cn/cashBack_act/pc_cashBack_2.png" alt="" @click="openQRcodeBox('pages/index/index', 400, 0)">
            <img src="https://pstatic.navi-sci.cn/cashBack_act/pc_cashBack_3.png" alt="" @click="openQRcodeBox('pages/index/index', 400, 0)">
            <img src="https://pstatic.navi-sci.cn/cashBack_act/pc_cashBack_4.png" alt="" @click="openQRcodeBox('pages/index/index', 400, 0)">
        </div>
        <div v-if="openQRcode" class="QRcode-box">
            <div class="QRcode-box-content">
                <img src="https://pstatic.navi-sci.cn/cashBack_act/pc_cashBack_QrCode_.png" alt="">
                <i class="el-icon-close" @click="openQRcode = false"></i>
                <div v-if="!qr_loading" class="QRcode-main">
                    <img :src="QRCode_main">
                </div>
                <div v-else v-loading="qr_loading" class="loading-box"></div>
            </div>
        </div>
    </div>
</template>

<script>
import { getCashBackDetail, getQRcode } from '@/api/request'

export default {
    data() {
        return{
            loading: false,
            qr_loading: false,
            cashBack_detail: {},//下单返现活动详细信息
            openQRcode: false,//二维码弹窗开关
            QRCode_main: null,//二维码链接
        }
    },
    created() {
        this.loading = true
        getCashBackDetail().then(res => {
            this.cashBack_detail = res.data
            this.loading = false
        })
    },
    methods: {
        // 生成跳转小程序的二维码
        openQRcodeBox(path,width,scene) {
            this.openQRcode = true
            this.qr_loading = true
            getQRcode(path,width,scene).then(res=>{
                this.QRCode_main = 'data:image/png;base64,' + res.qrCodeBytes
                this.qr_loading = false
            })
        },
        //跳转订单列表页
        toOrderList() {
            this.$router.push({
                path: "/aboutUsIndex",
                query: {
                    type:13,
                    tabIndex:'2-1',
                    tabName: '我的订单'
                }
            }); 
        },
        //跳转我的发票页
        toInvoiceList() {
            this.$router.push({
                path: "/aboutUsIndex",
                query: {
                    type:13,
                    tabIndex:'3-2',
                    tabName: '我的发票'
                }
            });
        },
    },
}
</script>

<style lang="scss" scoped>
.app-container {
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    height: 2400px;
    background: url(https://pstatic.navi-sci.cn/cashBack_act/pc_cashBack_BG.jpg) no-repeat center;
}
.myIncome {
    position: relative;
    top: 375px;
    width: 900px;
    height: 220px;
    .title {
        font-size: 28px;
        font-weight: 800;
    }
    .income-info {
        display: flex;
        justify-content: space-between;
        .income-info-item {
            display: flex;
            flex-direction: column;
            justify-content: flex-start;
            align-items: center;
            width: 200px;
            padding-top: 25px;
            .item {
                color: #D52222;
                font-size: 38px;
                font-weight: 800;
            }
            .item-text-1 {
                font-size: 32px;
            }
            .item-text-2 {
                font-size: 18px;
                margin-top: 15px;
            }
            .item-text-3 {
                display: flex;
                justify-content: center;
                align-items: center;
                padding: 5px 18px;
                color: #ffffff;
                margin-top: 15px;
                border-radius: 3px;
                background-color: #4D6DCF;
            }
            .item-text-4 {
                color: #4D6DCF;
                margin-top: 15px;
            }
        }
    }
}
.redPacket-explain {
    position: relative;
    top: 480px;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    align-items: center;
    width: 640px;
    height: 150px;
    padding: 15px;
    border: 2px solid #A88F74;
    border-radius: 15px;
    background-color: #FFFFFF;
    .explain-text-1{
        font-size: 38px;
        font-weight: 800;
        color: #D52222;
    }
    .explain-text-2{
        font-size: 24px;
        font-weight: 600;
    }
    .explain-text-3{
        font-size: 20px;
        font-weight: 600;
    }
}
.redPacket-box {
    position: relative;
    top: 500px;
    display: flex;
    justify-content: space-between;
    width: 880px;
    img {
        width: 150px;
        cursor: pointer;
    }
}
@keyframes openQRcode {
    0% {
        transform: scale(0.5);
    }

    100% {
        transform: scale(1);

    }
}

.QRcode-box {
    position: fixed;
    top: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);

    .QRcode-box-content {
        animation: openQRcode linear 0.2s;
        position: relative;
        width: 500px;
        height: 700px;

        img {
            width: 500px;
            height: 700px;
        }

        .el-icon-close {
            position: absolute;
            top: 30px;
            right: 30px;
            color: #ffffff;
            transform: scale(4);
        }

        .QRcode-main {
            position: absolute;
            bottom: 150px;
            left: 50%;
            transform: translateX(-50%);
            width: 150px;
            height: 150px;
            border-radius: 50%;
            background-color: #ffffff;
            img {
                width: 150px;
                height: 150px;
                border-radius: 50%;
            }
        }
        .loading-box {
            position: absolute;
            bottom: 230px;
            left: 230px;
        }
    }
}
</style>